import type { IconNode } from '../types';

/**
 * @name letter-k
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcgNCA2IDE1IiAvPgogIDxwYXRoIGQ9Ik02IDIwVjQiIC8+CiAgPHBhdGggZD0ibTkgMTIgOCA4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/letter-k
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const LetterK: IconNode = [
  ['path', { d: 'M17 4 6 15' }],
  ['path', { d: 'M6 20V4' }],
  ['path', { d: 'm9 12 8 8' }],
];

export default LetterK;
